// @flow
/* eslint-disable import/default */
import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { ThemeProvider } from 'styled-components';
import TagManager from 'react-gtm-module';

import theme from './themes/themes';

/**
 * Configure the redux store
 */
import configureStore from './store/configureStore';

// nitro theme
import applyTheme from './themes/theme';

// reset Ant Design theme
// calling this function to remove normalize.css from the page
import resetAntTheme from './themes/resetAntTheme';

// API interceptors
import ApiInterceptor from './interceptors/ApiInterceptor';
import MockInterceptor from './interceptors/MockInterceptor';

// material ui theme
import { muiTheme } from './themes/theme-material-ui';

/**
 * Retrieve token from localStorage and set as default header
 */
import { setAuthorizationToken } from './auth/persistance';

import { loadScript } from './utils/loadScript';

import constants from './constants';

const TagMgrArgs = {
  gtmId: constants.GTM_ID,
  auth: constants.GTM_AUTH,
  preview: constants.GTM_PREVIEW,
  dataLayer: {
    domain: window.location.hostname,
    userId: window.localStorage.getItem('auth/refId') || ''
  }
};

TagManager.initialize(TagMgrArgs);

loadScript(
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyAuhokQwqcbwU9L2U39Z1hG8VKiMVLKVOE&libraries=places'
);

/**
 * Routing
 */
import createRoutes from './routes/';

injectTapEventPlugin();
const store = configureStore();
store.asyncReducers = {};
applyTheme();
resetAntTheme();
// Passing the store to the inteterceptor to dispatch the notifications to be handled by the snack bar in the App.js
ApiInterceptor.configAPICallsWithErrorHandle(store);
// only if the parameter is true the mocking is done. In case of empty param or false param.. its live connection.
MockInterceptor.configResponseMockData(false);

const token = localStorage.getItem('auth/token');
setAuthorizationToken(token);

const routes = createRoutes(store);

/**
 * Render the application
 */
render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <MuiThemeProvider muiTheme={muiTheme}>
        <Router
          history={browserHistory}
          routes={routes}
          onUpdate={() => window.scrollTo(0, 0)}
        />
      </MuiThemeProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js